// extracted by mini-css-extract-plugin
module.exports = {"cls1":"InferenceInspectorPage-Outputs-module--cls1--3kIpO","cls2":"InferenceInspectorPage-Outputs-module--cls2--20gxq InferenceInspectorPage-Outputs-module--cls1--3kIpO"};